import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EventFeedbackSettings } from 'types/questions.types';
import { SCHEDULE_UNIT } from 'constants/enums';

import { FeedbackSettingsFragment } from '../common';

export interface UpdateEventFeedbackSettingsInput {
  eventId: number;
  isFeedbackAnonymous: boolean;
  feedbackSchedule: {
    quantity?: number;
    unit?: typeof SCHEDULE_UNIT[keyof typeof SCHEDULE_UNIT];
    beforeEventEnds?: boolean;
    sendAt?: string;
  };
  notificationChannel: {
    email: boolean;
    slack: boolean;
  };
}

export interface UpdateEventFeedbackSettingsResult {
  updateEventFeedbackSettings: {
    ok: boolean;
    event: EventFeedbackSettings;
  };
}

const UpdateEventFeedbackSettingsMutation = gql`
  mutation updateEventFeedbackSettings($input: UpdateEventFeedbackSettingsInput!) {
    updateEventFeedbackSettings(input: $input) {
      ok
      event {
        ...FeedbackSettingsFragment
      }
    }
  }
  ${FeedbackSettingsFragment}
`;

export const updateEventFeedbackSettings = (
  input: UpdateEventFeedbackSettingsInput
): Promise<UpdateEventFeedbackSettingsResult> => {
  return gqlClient.request<UpdateEventFeedbackSettingsResult>(UpdateEventFeedbackSettingsMutation, {
    input
  });
};
